export default __webpack_public_path__ + "static/media/light-bottom.bc2c589f.webp";